const asyncRouteSettings = {
  open: false,//是否开启动态路由功能
  defaultRoles: ["admin"]
}

export default asyncRouteSettings
